// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { buttonTransparent } from "@keller/XDL/PreStyle/button";
import { xBaseTheme } from "@keller/XDL/types";
import { getSystemColor } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        typographyProps: {
            size: 12,
            weight: "bold",
            color: getSystemColor("common.white", 0.66),
            css: css`
                margin: 0;
                letter-spacing: 0;
                line-height: 15px;
                overflow-wrap: anywhere;
            `,
        },
        color: "common.ui7",
        iconProps: {
            size: 14,
            src: "X",
        },
        mergeCss: true,
        css: css`
            min-height: 24px;
            flex-direction: row-reverse;
            align-items: flex-start;
            border-radius: 14px;
            padding: 4px 8px;
            button {
                margin-top: 1px;
                margin-right: 8px;
                ${buttonTransparent}
            }
        `,
    },
} as xBaseTheme["tag"];
